import type { SVGProps } from "react";

const BannerShapes = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={1274}
    height={642}
    viewBox="0 0 1274 642"
    fill="none"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M294.689 159.345L304.066 149.967L310.034 144L316.001 149.967L294.689 171.28L288.721 165.312L279.344 155.935L269.966 165.312L263.999 171.28L258.035 165.312L248.657 155.935L239.28 165.312L233.312 171.28L227.345 165.312L212 149.967L217.967 144L233.312 159.341L242.69 149.967L248.657 144L254.621 149.967L263.999 159.345L273.376 149.967L279.344 144L285.311 149.967L294.689 159.345Z"
      fill="#F70F3D"
    />
    <path
      d="M1244.53 281.297L1245.82 280H1243.22L1244.53 281.297Z"
      fill="#1A3ECC"
    />
    <path
      d="M1274 310.782V307.553L1272.39 309.168L1274 310.782Z"
      fill="#1A3ECC"
    />
    <path
      d="M41.4982 135.713L40.7851 135L0 175.785L40.7851 216.57L41.4982 215.847V135.713Z"
      fill="#D9A04C"
    />
    <path
      d="M176.439 455.326L153.812 477.953L176.439 500.581L199.066 477.953L176.439 455.326Z"
      fill="#B0813D"
    />
    <path
      d="M114.627 455.333L92 477.96L114.627 500.588L137.255 477.96L114.627 455.333Z"
      fill="#D9A04C"
    />
    <path
      d="M926.503 641.53L939.022 629.021L926.503 616.502V641.53Z"
      fill="#F70F3D"
    />
    <path
      d="M953.433 616.502V641.53L965.951 629.021L953.433 616.502Z"
      fill="#D6002B"
    />
    <path
      d="M1171.64 446.438V435.871H1182.2V432.622H1171.64V422.064H1168.39V432.622H1157.82V435.871H1168.39V446.438H1171.64Z"
      fill="#0038D6"
    />
    <path
      d="M182.806 286.374V275.806H193.374V272.558H182.806V262H179.558V272.558H169V275.806H179.558V286.374H182.806Z"
      fill="#0038D6"
    />
    <path
      d="M316 545.596C316 584.836 347.802 616.638 387.042 616.638C426.282 616.638 458.084 584.836 458.084 545.596C458.084 543.714 457.985 541.852 457.847 540H419.537C419.845 541.822 420.023 543.684 420.023 545.596C420.023 563.809 405.256 578.567 387.052 578.567C368.848 578.567 354.061 563.809 354.061 545.596C354.061 543.684 354.23 541.822 354.547 540H316.238C316.089 541.852 316 543.714 316 545.596Z"
      fill="#6B22C4"
    />
    <path
      d="M387.042 578.567C405.256 578.567 420.013 563.8 420.013 545.596C420.013 543.684 419.845 541.822 419.528 540H354.547C354.24 541.822 354.062 543.684 354.062 545.596C354.062 563.809 368.829 578.567 387.032 578.567H387.042Z"
      fill="#984CF5"
    />
    <path
      d="M903.73 363C864.11 363 832 395.11 832 434.73H975.46C975.46 395.12 943.34 363 903.73 363Z"
      fill="#F70F3D"
    />
    <path
      d="M904.01 0C850.428 0 807 43.428 807 97.01C807 150.592 850.428 194.02 904.01 194.02C957.592 194.02 1001.02 150.592 1001.02 97.01C1001.02 43.428 957.58 0 904.01 0ZM904.01 129.351C886.145 129.351 871.669 114.875 871.669 97.01C871.669 79.1452 886.145 64.6692 904.01 64.6692C921.875 64.6692 936.351 79.1452 936.351 97.01C936.351 114.875 921.875 129.351 904.01 129.351Z"
      fill="#6B22C4"
    />
    <path
      d="M1102.18 189L1061 230.182L1102.18 271.364L1143.36 230.182L1102.18 189Z"
      fill="#D9A04C"
    />
  </svg>
);

export default BannerShapes;